import React from 'react';
import styles from './GoToImmersiveGiving.scss';
import classNames from 'classnames';

export const GoToImmersiveGiving: React.FunctionComponent = () => (
  <>
    <section className={styles.container}>
      <h2 className="jg-h4">Help build this refugee shelter</h2>
      <p>
        See how you can help build this shelter for a refugee family by donating
        items they need or fundraising for them
      </p>
      <a
        className={classNames('jg-btn', 'jg-btn--primary')}
        href="/jg-spa/otg-jg-immersivegiving-ui/"
      >
        Explore Refugee Shelter
      </a>
    </section>
  </>
);
